import API from '@/API/request';

export const activityQuery = {
    // 获取活动编号
    getActivityCode: (params) => API.get('/activity/code', params),
    // 获取活动类型列表
    getActivityType: (params) => API.get('/config/activity_type/0', params),
    // 获取申请部门和费用归属部门 type: APPLAY(申请部门)  EXPENSE(费用归属部门)

    // 归属部门
    getDeptList: (params) => API.get(`/config/dept/list/${params.type}/${params.key}`),
    // 召回修改
    recallModification: (params) => API.put(`/approvecenter/recall/${params}`),
    // 获取所有费用审批记录
    getAllProcessHistory: (params) => API.get(`/approvecenter/all_process_history/${params}`),
    // 获取所有报备费用审批记录
    getAllReportProcessHistory: (params) => API.get(`/report-approve/all_process_history/${params}`),
    // 获取活动类型列表
    getExpenseTypeList: (params) => API.get('/expense_relate/expense_type_list'),
    // 活动评价
    activityAssessment: (params) => API.post('/activity/activity_evaluation', params),
    // 报备召回修改
    reportRecall: (params) => API.get(`/report-approve/recall/${params}`),
    // 合规召回
    complianceRecall: (params) => API.put(`/compliance/approve/recall/${params}`),
    // 合规审批记录
    complianceProcessHistory: (params) => API.get(`/compliance/approve/all_process_history/${params}`),
    // 合规上传附件资料
    complianceUpload: (params) => API.post(`/compliance/approve/submit`, params),
    // 合规审批通过
    complianceApproved: (params) => API.put(`/compliance/approve/approved`, params),
    // 合规审批通过
    complianceRejected: (params) => API.put(`/compliance/approve/reject`, params),
    // 导出活动列表（二进制流）
    exportActivityList: (params) => API.post(`/activity/export_activity_list`, params, {
        headers: {
            download: true
        },
        responseType: 'arraybuffer'
    }),
    // 导出报备列表（二进制流）
    exportReportList: (params) => API.post(`/report/export_report_list`, params, {
        headers: {
            download: true
        },
        responseType: 'arraybuffer'
    }),
    // 导出报备列表（二进制流）
    exportIndustrySummaryActivityList: (params) => API.post(`/activity/industry_summary/export_activity_list`, params, {
        headers: {
            download: true
        },
        responseType: 'arraybuffer'
    }),
    // 行业报备导出
    exportIndustryReportList: (params) => API.post(`/report/export_industry_report_list`, params, {
        headers: {
            download: true
        },
        responseType: 'arraybuffer'
    }),
    // 行业模板活动进度导出
    exportIndustryTemplateList: (params) => API.post(`/activity/industry_summary/export_summary_list`, params, {
        headers: {
            download: true
        },
        responseType: 'arraybuffer'
    })
};

export const activityQueryDetails = {
    // 获取基本信息
    getBasicInfoData: (params) => API.get(`/activity/market_activity/${params}`),
    // 获取报备基本信息
    getReportBasicInfoData: (params) => API.get(`/report/market_activity_detail/${params}`),
    // 获取二维码
    getQrCode: (params) => API.get(`/dm/qr_code/${params}`),
    // 获取二维码
    getToolKitData: (params) => API.get(`/config/template_activity/${params}`),
    // 获取文件的下载链接
    getDownloadUrl: (params) => API.get(`/file/url/${params}`),
    // 获取文件的下载链接
    getFileList: (params) => API.get(`/file/list/${params.activityCode}/${params.fileType}`),
    // 获取文件的下载链接
    deleteFile: (params) => API.delete(`/file/delete/${params}`),
    // 获取费用归属审批流
    getProcessHistory: (params) => API.get(`/approvecenter/process_history/${params}`),
    // 获取费用归属核销审批流
    getVerifyProcessLog: (params) => API.get(`/qd/write-off/form/log/${params}`),
    // 同意审批
    activistyCostApproval: (params) => API.put('/approvecenter/approved', params),
    // 驳回
    activistyCostReject: (params) => API.put('/approvecenter/reject', params),
    // 获取活动物料dm微页面详情
    getDmCustomerData: (params) => API.get(`/dm/customer/${params.activityCode}/${params.id}`),
    // 报备
    // 获取报备费用归属审批流
    getReportProcessHistory: (params) => API.get(`/report-approve/process-history/${params}`),
    // 同意审批
    reportApproval: (params) => API.post('/report-approve/approve', params),
    // 驳回
    reportReject: (params) => API.post('/report-approve/reject', params),
    // 获取ticketEncrypt
    getTicketEncrypt: () => API.get(`/ht/ticketEncrypt`),
    writeOffCheck: (params) => API.put(`/compliance/approve/writeOffCheck/${params.activityCode}`),
    specialWriteOffSubmit: (params) => API.post(`/special/write-off/submit/${params.expenseBelongId}`)

};

export const activistyCostAttribution = {
    // 费用撤销
    activistyCostRevoke: (params) => API.put(`/approvecenter/revoke/${params}`),
    // 报备费用撤销
    reportRevoke: (params) => API.get(`/report-approve/revoke/${params}`),
    // 获取费用部门的年息
    getAnnualInterest: ({ deptCode, expenseTypeCode }) => API.get(`/config/annual/interest/${deptCode}/${expenseTypeCode}`),
    // 模糊搜索用户账号信息
    getFinancialAccountByKey: ({ accountType, keyWord }) => API.get(`/config/annual/user/account_info/key/${accountType}/${keyWord}`),
    // 发起借款
    loanSubmit: (params) => API.post(`/activity/annual/form_loan`, params),
    // 获取费用系统的文件上传链接
    getFinancialUploadUrl: (params) => API.get(`/file/financial/up/url`),
    // 获取费用系统的文件下载链接
    getFinancialDownloadUrl: ({ fid }) => API.get(`file/financial/down/url/${fid}`),
    // 存储费用系统的文件信息
    saveFinancialFile: (params) => API.post(`file/financial/file`, params),
    // 点击“核销”时，校验活动信息和费用信息是否合法
    startWriteOff: (params) => API.get(`/expense_relate/startWriteOff/${params}`),
    // 根据渠道账号获取客商信息
    getBillingData: (params) => API.get(`/qd/write-off/billing/${params}`),
    // 渠道核销提交
    qdVerifySubmit: (params) => API.post(`/qd/write-off/info`, params),
    // 渠道核销驳回编辑提交
    qdVerifyEditSubmit: (params) => API.put(`/qd/write-off/info`, params),
    // 获取渠道核销信息
    getQdVerifyData: (params) => API.get(`/qd/write-off/info/${params}`),
    // 获取开户银行列表
    getDepositBankList: (params) => API.get('/qd/write-off/bank/register'),
    // 获取开户支行列表
    getDepositBranchList: (params) => API.get(`/qd/write-off/bank/branch/${params.bankCode}/${params.province}/${params.city}`),
    // 获取银行所在省市
    getRegionWhereBankList: (params) => API.get('/qd/write-off/bank/region'),
    // 获取核销历史数据
    getHistoryData: (params) => API.get(`/qd/write-off/bank-info/lastest/${params}`),
    // 获取渠道核销文件预览url
    getFilePreviewUrl: (params) => API.get(`/file/financial/view/url/${params}`),
    // 获取渠道核销单打印信息
    getPrintData: (params) => API.get(`/qd/write-off/print/${params}`)
};

export const travellingTrader = {
    // 获取参会客户数据
    getTravellingTraderData: (params) => API.post('/customer/list', params),
    // 查询客户列表
    getCustomerList: (params) => API.post('/customer/', params),
    // 批量添加参会客户
    customerSubmit: (params) => API.post('/customer/submit', params),
    // 添加客商合规检验
    verificationCustomer: (params) => API.post('compliance-verification/customer', params),
    // 参会客户删除
    customerDelete: (params) => API.post('/customer/deletion', params),
    // 参会客户状态修改
    customerStateChange: (params) => API.post(`/customer/stat/${params.customerStateCode}`, params.idList),
    // 参会客户编辑提交
    setCustomerList: (params) => API.put('/customer/', params),
    // 下载模板2(活动结束后的模板) - 测试
    // getDownloadTemplate: (params) => API.get('/file/url/17919372244504576', params),
    // // 下载模板1(新建申请的模板) - 测试
    // getDownloadTemplate1: (params) => API.get('/file/url/15856921475338240', params),
    // 下载模板2(活动结束后的模板) - 生产
    getDownloadTemplate: (params) => API.get('/file/url/17919372787224576', params),
    // 下载模板1(新建申请的模板) - 生产
    getDownloadTemplate1: (params) => API.get('/file/url/17463266892025856', params), // 16115518107570176 16471241940471808
    // excel导入客户
    importCustomer: (params) => API.post('/customer/excel', params),
    exportCustomerZx: (params) => API.post(`/customer/excelExportForUpdate`, params, {
      headers: {
        download: true // 局部覆盖
      },
      responseType: 'arraybuffer'
    }),
    // excel导出客户
    exportCustomer: (params) => API.get(`/customer/customerExcel?${params}`),
    // 需求验证
    getVerification: (params) => API.post(`/customer/verification`, params),
    // 需求验证
    sendCRMLead: (params) => API.post(`/customer/sendCRMLead`, params),
    // 新建crm客户校验
    addToCrm: (params) => API.post(`/customer/addToCrm`, params),
    // 新建crm客户校验
    getNeedChooseList: () => API.get(`/customer/dictionary `),
    // 同步crm
    updateCrm: (code) => API.get(`/customer/update/${code}`),
    // 活动申请列表-参会客户单位-目标业务机会推动个数获取
    getBusOppNum: (params) => API.get(`/activity/apply/customer/getBusOppNum`, { params })
};

export const drafts = {
    // 删除草稿
    draftDelete: (params) => API.delete(`/activity/market_activity/${params}`)
};

export const eps = {
    // 跳转非生产采购申请页面
    directEPSApply: (params) => API.post(`/expense_relate/eps/${params}`),
    // 跳转非生产采购列表页面
    directEPSPage: (params) => API.post(`/expense_relate/eps/page`)
};

// 活动质量统计接口
export const activityQualityStatistics = {
    // 获取活动质量统计数据
    // getQualityStats: (params) => API.get('/activity/apply/activityQuality', params)
    getQualityStats: (params) => API.get('/activity/apply/activityQuality?activityCode=' + params.activityCode)
};
